<template>
  <b-form-group :label="value.label">
    <b-form-select :placeholder="value.label" v-model="value.value" :options="options"/>
  </b-form-group>
</template>

<script>
    export default {
        props: ['value'],

        computed: {
            options() {
                let options = this.value.meta.options;
                options.unshift({value: null, text: '-- Maak een selectie'});

                return options;
            }
        }
    }
</script>
